// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".next,.prev{color:#525252}.next{position:absolute!important;right:0!important}.dots{position:absolute;display:block;bottom:35%;left:50%;transform:translateY(-50%) translateX(-50%)}.dot2{width:7px;height:7px;border-radius:3px;background:#c6c6c6;display:inline-block;margin:0 3px;transition:opacity .4s ease-in-out,width .4s cubic-bezier(.175,.885,.32,1.275)}.dot2--active{background:#262626}", ""]);
// Exports
module.exports = exports;
